import React from 'react'
import type { LoyaltyTier } from '../../../../types/loyalty'
import { TIER_LABEL, TIER_PALETTE, normalizeTier } from '../../utils/tier'

interface TierBadgeProps {
  tier: LoyaltyTier | 'unknown' | null | undefined
}

export const TierBadge: React.FC<TierBadgeProps> = ({ tier }) => {
  const normalized = normalizeTier(tier)
  const palette = TIER_PALETTE[normalized]
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 10px',
        borderRadius: 20,
        fontSize: 11.5,
        fontWeight: 600,
        background: palette.bg,
        color: palette.fg,
      }}
    >
      {TIER_LABEL[normalized]}
    </span>
  )
}
